// extracted by mini-css-extract-plugin
module.exports = {"Form":"Form__Form___3Z2dr","AssignTabs":"Form__AssignTabs___1H_Iu","AssignBody":"Form__AssignBody___1UEaO"};